import { render } from "./RegistryConfigs.vue?vue&type=template&id=031bab2a"
import script from "./RegistryConfigs.vue?vue&type=script&lang=js"
export * from "./RegistryConfigs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__